// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__1Gz3M","menu-text":"classes_menu-text__tVJS6"};